"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mitekMockService = void 0;
const mitekMockRepository_1 = require("../infra/repositories/mitekMockRepository");
exports.mitekMockService = {
    fetchMitekMock: ({ API, decision, progressId }) => (0, mitekMockRepository_1.fetchMitekMock)({ API, decision, progressId }).then(response => response.data),
};
//# sourceMappingURL=mitekMockService.js.map